import cookieManager from '../../../../utils/cookieManager';
import axios from '@/enhancers/axios';
import AssignmentActions from '../../../../reducers/modules/user/assignment/actions';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { Navigate } from 'react-router-dom';

const MySwal = withReactContent(Swal)
const url=process.env.REST_URL +'user-access/assignment'

export default class AssignmentMiddleware {

  static beforeAssign(data,id){
    return (dispatch) => {
      dispatch(AssignmentActions.beforeAssign());
      AssignmentMiddleware.assign(dispatch, data,id);
    };
  }

  static assign(dispatch,data,id){
    axios({
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${AssignmentMiddleware.getToken()}`
        },
        url:url+'/'+id,
        responseType: 'json',
        data:data
      })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(AssignmentActions.afterAssign(response.data.result));
          AssignmentMiddleware.alertHendler(dispatch, response, true, 'Save Data Successfully', 'success')
        }
      })
      .catch((error) => {
        AssignmentMiddleware.alertHendler(dispatch,error)
      });
  }


  static beforeRevoke(data,id){
    return (dispatch) => {
      dispatch(AssignmentActions.beforeRevoke());
      AssignmentMiddleware.revoke(dispatch, data,id);
    };
  }

  static revoke(dispatch,data,id){
    axios({
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${AssignmentMiddleware.getToken()}`
        },
        url:url+'/'+id,
        responseType: 'json',
        data:data
      })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(AssignmentActions.afterRevoke(response.data.result));
          AssignmentMiddleware.alertHendler(dispatch, response, true, 'Save Data Successfully', 'success')
        }
      })
      .catch((error) => {
        AssignmentMiddleware.alertHendler(dispatch,error)
      });
  }

  static create(params){
    return (dispatch) => {
      dispatch(AssignmentActions.create());
      AssignmentMiddleware.showHelper(dispatch, params);
    };
  }

  static update(params){
    return (dispatch) => {
      AssignmentMiddleware.showOne(dispatch, params);
      // dispatch(AssignmentActions.update());
    };
  }
  static resetList(){
    return (dispatch) => {
        dispatch(AssignmentActions.resetList());
      };
  }
  static list(params){
      return (dispatch) => {
          dispatch(AssignmentActions.process());
          AssignmentMiddleware.showlist(dispatch, params);
        };
  }
  static reset(){
    return (dispatch) => {
        dispatch(AssignmentActions.reset());
      };
}
  static getOne(params){
    return (dispatch) => {
        dispatch(AssignmentActions.view());
        AssignmentMiddleware.showOne(dispatch, params);
      };
  }

  static beforeSaveNew(post,search){
    return (dispatch) => {
        dispatch(AssignmentActions.submit());
        AssignmentMiddleware.saveNew(dispatch, post,search);
      };
  }
  static beforeSaveUpdate(params,post,search){
    return (dispatch) => {
        dispatch(AssignmentActions.submit());
        AssignmentMiddleware.saveUpdate(dispatch, params, post,search);
      };
  }
  static beforeDelete(id,params){
    return (dispatch) => {
        dispatch(AssignmentActions.delete());
        AssignmentMiddleware.delete(dispatch,params,id);
      };
  }

  static getToken(){
      return cookieManager.getUserToken();
  }

  static getHelper(params=null){
    return (dispatch) => {
      AssignmentMiddleware.showHelper(dispatch,params);
      };
  }

 
  static showHelper(dispatch,params){
    axios({
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${AssignmentMiddleware.getToken()}`
        },
        url:process.env.REST_URL+'helper/get-helper-admin' ,
        responseType: 'json',
        params:params
      })
      .then((response) => {
        
        if (response && response.status === 200 && response.data) {
          dispatch(AssignmentActions.helper(response.data.result));
        }
      })
      .catch((error) => {
        AssignmentMiddleware.alertHendler(dispatch,error)
      });
  }

  static showlist(dispatch, params){
      axios({
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${AssignmentMiddleware.getToken()}`
          },
          url: url,
          responseType: 'json',
          params:params
        })
        .then((response) => {
          
          if (response && response.status === 200 && response.data) {
            dispatch(AssignmentActions.list(response.data.result));
          }
        })
        .catch((error) => {
          AssignmentMiddleware.alertHendler(dispatch,error)
        });
  }

  static showOne(dispatch, params){
    axios({
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${AssignmentMiddleware.getToken()}`
        },
        url: url +'/'+params,
        responseType: 'json'
      })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(AssignmentActions.view(response.data.result));
        }
      })
      .catch((error) => {
        AssignmentMiddleware.alertHendler(dispatch,error)
      });
  }

  static delete(dispatch, params,id){
    axios({
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${AssignmentMiddleware.getToken()}`
        },
        url: url +'/'+id,
        responseType: 'json'
      })
      .then((response) => {
       
        if (response && response.status === 200 && response.data) {
          MySwal.close()
          dispatch(AssignmentActions.process(),AssignmentMiddleware.showlist(dispatch, params));
          AssignmentMiddleware.alertHendler(dispatch,response,true,'Delete Data Successfully','success')
        }
      })
      .catch((error) => {
        AssignmentMiddleware.alertHendler(dispatch,error,true)
      });
  }

  static saveNew(dispatch, post,search){
    axios({
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${AssignmentMiddleware.getToken()}`
        },
        url: url,
        data:post,
        responseType: 'json'
      })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(AssignmentActions.process(),AssignmentMiddleware.showlist(dispatch,search));
          dispatch(AssignmentActions.success());
          AssignmentMiddleware.alertHendler(dispatch,response,true,'Create Data Successfully','success')
        }
      })
      .catch((error) => {
        AssignmentMiddleware.alertHendler(dispatch,error)
      });
  }

  static saveUpdate(dispatch, params, post, search){
    axios({
        method: 'PUT',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Authorization: `Bearer ${AssignmentMiddleware.getToken()}`
        },
        url: url+'/'+params,
        data:post,
        responseType: 'json'
      })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(AssignmentActions.process(),AssignmentMiddleware.showlist(dispatch,search));
          dispatch(AssignmentActions.success());
          AssignmentMiddleware.alertHendler(dispatch,response,true,'Update Data Successfully','success')
        }
      })
      .catch((error) => {
        AssignmentMiddleware.alertHendler(dispatch,error)
      });
  }

  static alertHendler(dispatch,result,isSwal=false,extraMessage='',type='error'){
    if(type=='error'){
      if (result.response) {
        const status=result.response.status
        switch(status){
          
          case 500:
            if(isSwal){
              const data=result.response.data
              MySwal.hideLoading()
              MySwal.update({
                title:'Delete Error',
                html:data.error,
                icon:'error',
                showConfirmButton:true,
              })
            }else{
              const data=result.response.data
              dispatch(AssignmentActions.error(data.error));
            }
          break;  
          case 403:
            console.log('Error 403');
          break;     
          case 404:
            console.log('Error 404');
          break;   
          case 401:
            const data=result.response.data
              MySwal.fire({
                title:'Login Invalid',
                html:data.error,
                icon:'error',
                showConfirmButton:true,
              }).then((result)=>{
                  if(result.isConfirmed){
                    <Navigate to="/login"></Navigate>
                  }
              })
          break;   
        }
      } else if (result.request) {
        MySwal.fire({
          title:'Internal Server Error',
          html:'Please info your Developer to fix this',
          icon:'error',
          showConfirmButton:true,
        })
        dispatch(AssignmentActions.reset());
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', result.message);
      }
    }else{
      MySwal.fire({
        title:'Success',
        html:extraMessage,
        icon:'success',
        showConfirmButton:true,
      })
    }
  }
}
